import React from 'react';
import { Link } from 'react-router-dom';
import type { ProfileSectionNudge } from '../../utils/profileSectionNudges';
import './ProfileSectionNudgeCard.css';

type ProfileSectionNudgeCardProps = {
  nudge: ProfileSectionNudge;
  onDismiss: () => void;
};

const ProfileSectionNudgeCard: React.FC<ProfileSectionNudgeCardProps> = ({ nudge, onDismiss }) => {
  const progressPercent = Math.max(0, Math.min(100, Math.round(nudge.percent)));

  return (
    <div className={`profile-section-nudge-card ${nudge.positionClass}`} role="status">
      <button
        type="button"
        className="profile-section-nudge-close"
        onClick={onDismiss}
        aria-label="Dismiss profile tip"
      >
        ×
      </button>
      <div className="profile-section-nudge-badge">{progressPercent}% screening ready</div>
      <div className="profile-section-nudge-title">{nudge.title}</div>
      <p className="profile-section-nudge-copy">{nudge.message}</p>
      <div
        className="profile-section-nudge-progress-track"
        role="progressbar"
        aria-valuenow={progressPercent}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label="Screening readiness"
      >
        <div
          className="profile-section-nudge-progress-fill"
          style={{ width: `${progressPercent}%` }}
        />
      </div>
      <Link className="profile-section-nudge-cta" to={nudge.ctaPath} onClick={onDismiss}>
        {nudge.ctaLabel}
      </Link>
    </div>
  );
};

export default ProfileSectionNudgeCard;
